/* eslint-disable */
import { USER_REGISTERED, USER_LOGGED_IN, LOGOUT } from '../redux/constants/index';
import { register as registerUser, login as loginUser } from '../api/api.js'
import handle from '../utilities/errorHandler';
import debug from 'debug';

//custom debugging output
const output = debug('auth');

export const register = (formData) => async (dispatch) => {
    try {
        const response  = await registerUser(formData);
        const { data } = response;
        output("Auth Response", data);

        localStorage.setItem('profile', JSON.stringify(data));

        dispatch({
            type: USER_REGISTERED,
            payload: data
        })

    } catch (error) {
        handle(error, dispatch);
    }
}

export const signIn = (formData) => async (dispatch) => {
    try {
        const response = await loginUser(formData);
        const { data } = response;
        output("Auth Response", data);

        localStorage.setItem('profile', JSON.stringify(data));

        dispatch({
            type: USER_LOGGED_IN,
            payload: data
        })
        
    } catch (error) {
        console.log(error);
        handle(error, dispatch);
    }
}

export const logout = () => (dispatch) => {
    localStorage.removeItem("profile");
    dispatch({type: LOGOUT});
}